import React from "react"
import "./InformationBox.scss"

type InformationBoxProps = {
	children?: React.ReactNode
	backgroundColor: React.CSSProperties["color"]
}

const InformationBox = (props: InformationBoxProps) => {
	const { children, backgroundColor } = props

	return (
		<div className="information-box">
			<figure className="information-box-icon" style={{ backgroundColor }} />
			{children}
		</div>
	)
}

export default InformationBox
